import gql from 'graphql-tag';

export const TESTATOR_STEPS_QUERY = gql`
  query Testator($id: ID!) {
    testator(id: $id) {
      id
      fullName
      willDetailsChanged
      previewWillDetailsChanged
      enabledFeatures
      steps {
        id
        aboutYourself
        people
        assets
        specificDonations
        remainderOfEstate
        letterOfWishesAndLivingWill
        insurance
      }
      willVersions {
        id
      }
      previewWillVersions {
        id
      }
      company {
        id
        tradingName
        logoUrl
        executorship
        contactCenterWorkflow
        advisorAppointment
        referAFriend
        willDownloadLanguages
      }
      advisor {
        id
        fullName
        email
        appointmentLink
      }
    }
  }
`;
